export const MIN_VEHICLE_YEAR = 1901

export function getVehicleYearOptions(maxYear: number = new Date().getFullYear()): number[] {
  return Array.from({ length: maxYear - MIN_VEHICLE_YEAR + 1 }, (_, i) => maxYear - i)
}
